<template>
  <div>
    <div class="home" v-if="isMobile">
      <div style="margin-bottom: 50px; width: 100%; height: 500px">
        <img
          style="width: 100%; height: 500px"
          src="../assets/gonggufuwu.jpg"
          alt=""
        />
      </div>
      <div class="aboutUs">
        <div class="aboutUs-title">
          <div class="underline"></div>
          <div class="aboutUs-title-name">公估服务</div>
        </div>
        <div class="aboutUs-content"  >
          <div>
            <div class="title">众估宝服务框架：</div>
            <div class="line"></div>
            <div class="framework">
              <img src="../assets/Group 37376.png" alt="">
              <ul class="framework-des" style="top: 38px; left: 600px;">
                <li>集中查看筛选全国各家公估公司综合服务能力，择优或竞价进行线上委托派件</li>
                <li>一站式案件全流程监控和日常数据分析服务</li>
              </ul>
              <ul class="framework-des framework-des-right" style="top: 400px; left: 102px;text-align: right;">
                <li>公估案件线上查看、竞价与承接服务</li>
                <li>公估人员考核、培训、评价等 </li>
                <li>运营信息管理工具</li>
              </ul>
              <ul class="framework-des" style="top: 400px; left: 602px;">
                <li>保险公估链条SaaS服务平台</li>
                <li>自有理赔公估团队</li>
                <li>为双方提供各项信息技术支持与增值服务</li>
              </ul>
            </div>
            <div class="title" style="margin-top: 64px;">众估宝服务类型：</div>
            <div class="line"></div>
            <div class="content-wrap">
              <div class="content-item">
                <div class="item-title">平台服务</div>
                <div class="item-content">保险公司与公估公司使用平台进行派单与接单。保司可使用指派、竞价模式，根据案件要求和标准，选择最优公估公司开启调查服务。</div>
              </div>
              <div class="content-item">
                <div class="item-title">专向对接</div>
                <div class="item-content">具备非车大案处理能力的公估公司经审核后进入平台优选库。针对合作保司的特别大案，众估宝提供推荐承接服务。</div>
              </div>
              <div class="content-item">
                <div class="item-title">自营理赔外包</div>
                <div class="item-content">自有专业理赔团队可向保司承接全流程理赔外包服务 此外，众估宝自主开发的闪赔系统，除了专业人才服务外，还可免费提供系统支持。</div>
              </div>
            </div>
            <div class="title" style="margin-top: 64px;">众估宝平台设计思路 ：</div>
            <div class="line"></div>
            <div class="thinking">
              <div>
                <div class="thinking-item" style="margin-top: 80px;">
                  <div class="thinking-title">聚合</div>
                  <div class="thinking-content">为保险公司在选择公估机构上提供多样性，弥补时效上及地域上的不足。</div>
                </div>
                <div class="thinking-item" style="margin-top: 190px;">
                  <div class="thinking-title">细分</div>
                  <div class="thinking-content">将案件环节进行细分，分为首次联系、调查取证、初期报告、会商处理意见、保司意见、正式公估报告与证据材料、系统处理意见（要求提交纸质报告和发票、线下寄送时限）。</div>
                </div>
                <div class="thinking-item" style="margin-top: 100px;">
                  <div class="thinking-title">对接</div>
                  <div class="thinking-content">帮助对接专业律师服务，满足公估公司或保险公司对公估案件在法律支持的需要。</div>
                </div>
              </div>
              <img src="../assets/Group 37371.png" alt="">
              <div>
                <div class="thinking-item" style="margin-top: 80px;">
                  <div class="thinking-title">竞价</div>
                  <div class="thinking-content">提供竞价派件功能，保险公司可以将委托的案件，派发到案件池，描述案件情况、设置各环节时效、预设的公估费用和奖励后，由公估公司进行竞价投标，价优或服务优者中标。</div>
                </div>
                <div class="thinking-item">
                  <div class="thinking-title" style="margin-top: 114px;">培训</div>
                  <div class="thinking-content">设置每年培训学时考核。公估公司经办人要每年参加系统提供的48学时的网络学习课程，不达标者则失去次年系统接案资格，需要重新参加系统设置的资格考试。</div>
                </div>
                <div class="thinking-item">
                  <div class="thinking-title" style="margin-top: 90px;">委派</div>
                  <div class="thinking-content">保险公司可以查看系统上的公估公司日常服务数据，直接派件给最优的公估机构，提高案件处理时效。</div>
                </div>
              </div>
            </div>
            <div class="title" style="margin-top: 64px;">公估人员 ：</div>
            <div class="line"></div>
            <div class="people">
              <div class="people-type">
                <div>保险调查公司中的独立调查人员</div>
                <div>保险调查公司中的独立调查人员</div>
                <div>具有医疗从业资格证的相关人员</div>
                <div>具有法律服务资格证的相关人员</div>
                <div>具有理算医审从业工作经验的人员</div>
                <div>希望从事公估调查的保险从业者 或</div>
                <div>应届毕业生</div>
              </div>
              <img src="../assets/Group 37373.png" alt="">
              <div class="people-role">
                <div>按照准入险种分类，具备相关险种接案权限</div>
                <div style="margin-top: 53px;">严格按照监管要求规范操作实务</div>
                <div style="margin-top: 30px;">每案处理过程监控，处理结果评价，通过量化数据最终形成公估人员星级评分</div>
              </div>
            </div>
            <div class="title" style="margin-top: 64px;">公估公司与人员双评价机制 ：</div>
            <div class="line"></div>
            <div class="evaluate">
              <div class="company">
                <div class="company-type"><div style="margin-top: 14px;line-height: normal">众估</div><div style="margin-top: 5px;line-height: normal">公司</div></div>
                <div>公司信息 </div>
                <div>服务口碑星级 </div>
                <div>案件处理流程</div>
                <div>月度、季度、年度评价数据</div>
                <div class="company-tips">
                  签约的公估公司，接案必须提供各分机构公估人员信息，证明承接能力，避免异地经营虚报区域或违规转委托
                </div>
              </div>
              <div class="img-wrap">
                <img src="../assets/Vector 117.png" alt="">
                <img src="../assets/image 76.png" alt="">
                <img src="../assets/Vector 118.png" alt="">
              </div>
              <div class="company" style="text-align: left;">
                <div class="company-type" style="right: 10px;left: unset;"><div style="margin-top: 14px;line-height: normal">众估</div><div style="margin-top: 5px;line-height: normal">人员</div></div>
                <div>人员信息</div>
                <div>服务口碑星级 </div>
                <div>接案区域与险种 </div>
                <div>培训考核记录</div>
                <div>案件处理历史</div>
                <div class="company-tips">
                  合作保司可以穿透公估公司，查看其公估人员的接案信息与星级评价
                </div>
              </div>
            </div>
            <div class="title" style="margin-top: 64px;">众估宝技术服务亮点 ：</div>
            <div class="line"></div>
            <div class="highlights">
              <div class="content-item">
                <div class="item-title">流程再造</div>
                <div class="item-content">基于管理学思想和实际操作经验总结，梳理出一套完整科学的流程，极大提高服务时效性。</div>
              </div>
              <div class="content-item" style="margin-left: 36px;">
                <div class="item-title">科技赋能</div>
                <div class="item-content">专门研发了公估应用工具，主要功能含：被调查人员的身份验证、公估人员的卫星地图追踪以及语音和视频资料的线上化采集等。</div>
              </div>
              <div class="content-item">
                <div class="item-title">声谱分析</div>
                <div class="item-content">植入对采集的语音或视频资料的声谱分析功能，提供给合作保险公司作为判定案件调查结果可信性的参考依据。</div>
              </div>
              <div class="content-item" style="margin-left: 36px;">
                <div class="item-title">数据分析</div>
                <div class="item-content">可根据保险公司需求，定期或不定期提供合作公估公司在平台承接案件的服务质量数据，比如结案时效、减损成效、投诉情况等等。</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="" v-else>
      <div style="width: 100vw; height: 53.3333vw">
        <img
          style="width: 100%; height: 50vw"
          src="../assets/gonggufuwu.jpg"
          alt=""
        />
      </div>
      <div class="mCompanyProfile">
        <div class="mCompanyProfile-title">公估服务</div>
        <div class="section-title">众估宝服务框架：</div>
        <div class="line"></div>
        <div class="service-framewrok">
          <ul>
            <li>集中查看筛选全国各家公估公司综合服务能力，择优或竞价进行线上委托派件</li>
            <li>一站式案件全流程监控和日常数据分析服务</li>
          </ul>
          <img src="../assets/Group 37376.png" alt="">
          <div style="margin-top: 6.66vw;">
            <ul class="row-ul">
              <li>公估案件线上查看、竞价与承接服务</li>
              <li>保险公估链条SaaS服务平台</li>
            </ul>
            <ul class="row-ul">
              <li>公估人员考核、培训、评价等</li>
              <li>自有理赔公估团队</li>
            </ul>
            <ul class="row-ul">
              <li>运营信息管理工具</li>
              <li>为双方提供各项信息技术支持与增值服务</li>
            </ul>
          </div>
        </div>
        <div class="section-title">众估宝服务类型：</div>
        <div class="line"></div>
        <div>
          <div class="sence-item">
            <div class="sence-item-title">平台服务</div>
            <div class="sence-item-content">保险公司与公估公司使用平台进行派单与接单。保司可使用指派、竞价模式，根据案件要求和标准，选择最优公估公司开启调查服务。</div>
          </div>
          <div class="sence-item">
            <div class="sence-item-title">专向对接</div>
            <div class="sence-item-content">具备非车大案处理能力的公估公司经审核后进入平台优选库。针对合作保司的特别大案，众估宝提供推荐承接服务。</div>
          </div>
          <div class="sence-item">
            <div class="sence-item-title">自营理赔外包</div>
            <div class="sence-item-content">自有专业理赔团队可向保司承接全流程理赔外包服务 此外，众估宝自主开发的闪赔系统，除了专业人才服务外，还可免费提供系统支持。</div>
          </div>
        </div>
        <div class="section-title">众估宝平台设计思路 ：</div>
        <div class="line"></div>
        <div class="design">
          <img src="../assets/Group 37375.png" alt="">
          <div>
            <div class="design-wrap" style="margin-top: -3vw;">
              <div class="design-title">聚合</div>
              <div class="design-content">为保险公司在选择公估机构上提供多样性，弥补时效上及地域上的不足。</div>
            </div>
            <div class="design-wrap" style="margin-top: 7vw;">
              <div class="design-title">细分</div>
              <div class="design-content">将案件环节进行细分，分为首次联系、调查取证、初期报告、会商处理意见、保司意见、正式公估报告与证据材料、系统处理意见（要求提交纸质报告和发票、线下寄送时限）。</div>
            </div>
            <div class="design-wrap" style="margin-top: 8vw;">
              <div class="design-title">对接</div>
              <div class="design-content">帮助对接专业律师服务，满足公估公司或保险公司对公估案件在法律支持的需要。</div>
            </div>
            <div class="design-wrap" style="margin-top: -2vw;">
              <div class="design-title">竞价</div>
              <div class="design-content">提供竞价派件功能，保险公司可以将委托的案件，派发到案件池，描述案件情况、设置各环节时效、预设的公估费用和奖励后，由公估公司进行竞价投标，价优或服务优者中标。</div>
            </div>
            <div class="design-wrap" style="margin-top: 9vw;">
              <div class="design-title">委派</div>
              <div class="design-content">保险公司可以查看系统上的公估公司日常服务数据，直接派件给最优的公估机构，提高案件处理时效。</div>
            </div>
            <div class="design-wrap" style="margin-top: 7vw;">
              <div class="design-title">培训</div>
              <div class="design-content">设置每年培训学时考核。公估公司经办人要每年参加系统提供的48学时的网络学习课程，不达标者则失去次年系统接案资格，需要重新参加系统设置的资格考试。</div>
            </div>
          </div>
        </div>
        <div class="section-title">公估人员 ：</div>
        <div class="line"></div>
        <div class="people">
          <div class="people-type">保险调查公司中的独立调查人员</div>
          <div class="people-type">保险调查公司中的独立调查人员</div>
          <div class="people-type">具有医疗从业资格证的相关人员</div>
          <div class="people-type">具有法律服务资格证的相关人员</div>
          <div class="people-type">具有理算医审从业工作经验的人员</div>
          <div class="people-type">希望从事公估调查的保险从业者 或应届毕业生</div>
          <div style="display: flex;flex-direction: column;align-items: center;margin-top:10.66vw ">
            <img style="width: 41vw;height: 24vw;" src="../assets/image 74.png" alt="">
            <img style="width: 36.2vw;height: 17.6vw;margin-top:2.93vw " src="../assets/image 75.png" alt="">
          </div>
          <div class="people-item">
            <div class="people-item-content">按照准入险种分类，具备相关险种接案权限</div>
          </div>
          <div class="people-item">
            <div class="people-item-content">严格按照监管要求规范操作实务</div>
          </div>
          <div class="people-item">
            <div class="people-item-content">每案处理过程监控，处理结果评价，通过量化数据最终形成公估人员星级评分</div>
          </div>
        </div>
        <div class="section-title">公估公司与人员双评价机制 ：</div>
        <div class="line"></div>
        <div class="evaluate">
          <div class="company" style="padding-bottom: 43vw;">
            <div class="company-type"><div style="margin-top: 4.5vw;line-height: normal">众估</div><div style="margin-top: 5px;line-height: normal">公司</div></div>
            <div>公司信息 </div>
            <div>服务口碑星级 </div>
            <div>案件处理流程</div>
            <div>月度、季度、年度评价数据</div>
            <div class="company-tips">
              签约的公估公司，接案必须提供各分机构公估人员信息，证明承接能力，避免异地经营虚报区域或违规转委托
            </div>
          </div>
          <div class="img-wrap">
            <img src="../assets/Group 37374.png" alt="">
          </div>
          <div class="company" style="text-align: left;padding-bottom: 32vw;">
            <div class="company-type" style="right: 1vw;left: unset;"><div style="margin-top: 4.5vw;line-height: normal">众估</div><div style="margin-top: 5px;line-height: normal">人员</div></div>
            <div>人员信息</div>
            <div>服务口碑星级 </div>
            <div>接案区域与险种 </div>
            <div>培训考核记录</div>
            <div>案件处理历史</div>
            <div class="company-tips">
              合作保司可以穿透公估公司，查看其公估人员的接案信息与星级评价
            </div>
          </div>
        </div>
        <div class="section-title">众估宝技术服务亮点 ： </div>
        <div class="line"></div>
        <div>
          <div class="sence-item">
            <div class="sence-item-title">流程再造</div>
            <div class="sence-item-content">基于管理学思想和实际操作经验总结，梳理出一套完整科学的流程，极大提高服务时效性。</div>
          </div>
          <div class="sence-item" >
            <div class="sence-item-title">科技赋能</div>
            <div class="sence-item-content">专门研发了公估应用工具，主要功能含：被调查人员的身份验证、公估人员的卫星地图追踪以及语音和视频资料的线上化采集等。</div>
          </div>
          <div class="sence-item">
            <div class="sence-item-title">声谱分析</div>
            <div class="sence-item-content">植入对采集的语音或视频资料的声谱分析功能，提供给合作保险公司作为判定案件调查结果可信性的参考依据。</div>
          </div>
          <div class="sence-item">
            <div class="sence-item-title">数据分析</div>
            <div class="sence-item-content">可根据保险公司需求，定期或不定期提供合作公估公司在平台承接案件的服务质量数据，比如结案时效、减损成效、投诉情况等等。</div>
          </div>
        </div>
      </div>
      <!-- <div class="mOfficeEnvironment">
        <div class="mOfficeEnvironment-title">办公环境</div>
        <div class="mswiper">
          <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
            <van-swipe-item v-for="item in carouseData" :key="item">
              <img :src="item.url" alt="" />
            </van-swipe-item>
          </van-swipe>
        </div>
      </div> -->
    </div>
  </div>
</template>
  
<script>
import {
  getAboutUs,
  getHeadView,
  getOfficeEnvironment,
  getSubsidiaryCompany,
  getYear,
  getYearToMonth,
  getHistoryDetails,
} from "../http/api/api";
import serverConfig from "../http/config/index";
export default {
  name: "aboutUs",
  data() {
    return {
      aboutUsContent: "",
      aboutOurHeadChart: null,
      carouseData: [],
      activeIndex: 0,
      activeIndex2: 0,
      latestYear: "",
      companyDevelopmentBackground: "",
      yearList: [],
      monthList: [],
      electionMonth: "",
      historyDetails: "",
      isMobile: false,
    };
  },
  created() {
    this.checkDeviceType();
    window.addEventListener("resize", this.checkDeviceType);
    // this.getAboutUs();
    // this.getHeadView();
    // this.getOfficeEnvironment();
    // this.getYear();
    // this.getCompanyDevelopmentBackground();
    // setTimeout(() => {
    //   this.getHistoryDetails();
    // }, 500);
  },

  methods: {
    // to() {
    //   this.$refs["aboutUs"].scrollIntoView(true);
    // },
    // toWheelSeedingPicture() {
    //   this.$refs["wheelSeedingPicture"].scrollIntoView(true);
    // },
    switchingYear(item, index) {
      this.activeIndex2 = index;
      this.activeIndex = 0;
      this.latestYear = item?.yearM;
      this.getYearToMonth(item?.yearM);
      setTimeout(() => {
        this.getHistoryDetails();
      }, 300);
      console.log(item);
    },
    getYear() {
      getYear().then((res) => {
        this.latestYear = res.data[0]?.yearM;
        this.yearList = res.data;
        this.getYearToMonth(this.latestYear);
        console.log(res);
      });
    },
    getYearToMonth(year) {
      getYearToMonth(year).then((res) => {
        this.monthList = res.data;
        if (res.data.length >= 0) {
          this.electionMonth = res.data[0]?.yearM;
        }
      });
    },
    getHistoryDetails() {
      let yearM = this.latestYear + "-" + this.electionMonth;
      getHistoryDetails(yearM).then((res) => {
        if (res.data.length > 0) {
          this.historyDetails = res.data[0]?.commits;
        }
        console.log(res);
      });
    },
    selectOnlineItems(item, index) {
      this.activeIndex = index;
      this.electionMonth = item?.yearM;
      this.getHistoryDetails();
    },
    getAboutUs() {
      getAboutUs().then((res) => {
        console.log(res);
        this.aboutUsContent = res.data[0].content;
      });
    },
    getCompanyDevelopmentBackground() {
      getHeadView(20).then((res) => {
        res.data.forEach((item) => {
          this.companyDevelopmentBackground =
            serverConfig.baseURL + item.imgUrl;
        });
      });
    },
    getHeadView() {
      getHeadView(11).then((res) => {
        res.data.forEach((item) => {
          this.aboutOurHeadChart = serverConfig.baseURL + item.imgUrl;
        });
        console.log(this.aboutOurHeadChart);
      });
    },
    getOfficeEnvironment() {
      getOfficeEnvironment().then((res) => {
        let data = res.data.map((item) => {
          return { url: serverConfig.baseURL + item.imgUrl };
        });
        this.carouseData = data;
      });
    },
    checkDeviceType() {
      const userAgent = navigator.userAgent.toLowerCase();
      const minWidthForMobile = 768;
      if (
        userAgent.match(
          /(android|iphone|ipad|ipod|webos|blackberry|iemobile|opera mini)/i
        )
      ) {
        this.isMobile = false;
      } else if (window.innerWidth < minWidthForMobile) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.aboutUs {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 75px;
  .aboutUs-title {
    .underline {
      width: 180px;
      height: 4px;
      background: #dc1010; 
      // margin-top: 6px;
      // margin-bottom: 25px;
    }
    .aboutUs-title-name {
      font-size: 36px;
      font-weight: 500;
      color: #dc1010;
      margin-top: 20px;
    }
  }
  .aboutUs-content {
    width: 1000px;
    padding-top: 10px;
    box-sizing: border-box;
    font-size: 20px;
    font-weight: 400;
    color: #333333;
    line-height: 30px;
    .title{
      color: #333;
      font-weight: bold;
      font-size: 24px;
    }
    .line{
      margin-top: 20px;
      width: 266px;
      height: 6px;
      background: url("../assets/Group\ 37340.png") no-repeat;
      background-size: cover;
    }
    .framework{
      width: 100%;
      height: 511px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      img{
        width: 291px;
        height: 305px;
      }
      .framework-des{
        font-size: 16px;
        color: #666;
        line-height: 24px;
        font-weight: 500;
        position: absolute;
        li{
          margin-top: 12px;
          list-style: disc;
          &::marker{
              color: #BD2121;
              font-size: 24px;
              
          }
        }
      }
      .framework-des-right{
        li{
          margin-top: 12px;
          list-style: none;
          position: relative;
          padding-right: 30px;
        }
        li::after{
          content: '•'; /* Unicode for bullet */
          position: absolute;
          right: 0;
          color: #BD2121; /* Change color as needed */
          font-size: 30px; /* Adjust size as needed */
          top: 0;
          transform: translateY(-50%);
          transform: translateX(-50%);
        }
      }
    }
    .content-wrap{
      display: flex;
      justify-content: space-between;
    }
    .content-item{
      width: 284px;
      background: #FFFFFF;
      box-shadow: 0px 4px 12px 0px rgba(208,2,27,0.06);
      border-radius: 14px 14px 14px 14px;
      padding: 27px 18px;
      margin-top: 40px;
      .item-title{
        color: #DB222A;
        font-size: 22px;
        font-weight: bold;
      }
      .item-content{
        margin-top: 24px;
        text-indent: 2em;
        line-height: 44px;
        color: #666;
        font-size: 16px;
        font-weight: 500;
      }
    }
    .thinking{
      img{
        margin-top: 137px;
        width: 294px;
        height: 557px;
      }
      display: flex;
      .thinking-item{
        .thinking-title{
          font-weight: bold;
          font-size: 22px;
          color: #DB222A;
        }
        .thinking-content{
          margin-top: 12px;
          color: #666;
          font-size: 16px;
          font-weight: 500;
          text-indent: 2em;
        }
      }
    }
    .people{
      display: flex;
      justify-content: space-between;
      img{
        width: 381px;
        height: 280px;
        margin-top: 80px;
      }
      .people-type{
        width: 250px;
        flex-shrink: 0;
        margin-top: 80px;
        div{
          font-size: 16px;
          color: #333;
          font-weight: bold;
          line-height: 44px;
        }
      }
      .people-role{
        margin-top: 68px;
        div{
          padding: 12px 22px;
          font-size: 16px;
          color: #666;
          font-weight: 500;
          line-height: 44px;
          background: #FFFFFF;
          box-shadow: 0px 4px 12px 0px rgba(208,2,27,0.06);
          border-radius: 14px 14px 14px 14px;
        }
      }
    }
    .evaluate{
      display: flex;
      margin-top: 56px;
      height: 353px;
      align-items: center;
      .img-wrap{
          display: flex;
          img{
            &:nth-child(1){
              width: 101px;
              height: 3px;
            }
            &:nth-child(2){
              width: 89px;
              height: 99px;
              transform: translateY(-70%);
            }
            &:nth-child(3){
              width: 144px;
              height: 3px;
            }
          }
        }
      .company{
        width: 294px;
        height: 353px;
        position: relative;
        background: rgba(189,33,33,0.05);
        text-align: right;
        padding: 12px 24px;
        border-radius: 5px 5px 5px 5px;
        color: #666;
        font-size: 16px;
        font-weight: 500;
        line-height: 44px;
        
        .company-type{
          color: #fff;
          font-size: 14px;
          font-weight: bold;
          position: absolute;
          left: 10px;
          top: 10px;
          width: 73px;
          height: 73px;
          background: url("../assets/image\ 77.png") no-repeat;
          background-size: cover;
          text-align: center;
        }
        .company-tips{
          width: 100%;
          position: absolute;
          left: 0;
          bottom: 0;
          padding: 12px 16px;
          box-sizing: border-box;
          text-align: left;
          background: #FFFFFF;
          box-shadow: 0px 4px 12px 0px rgba(208,2,27,0.06);
          border-radius: 5px 5px 5px 5px;
          font-size: 16px;
          color: #666;
          font-weight: 500;
          line-height: 44px;
        }
      }
    }
    .highlights{
      display: flex;
      flex-wrap: wrap;
      .content-item{
        width: 44%;
      }
    }
  }
}

.m-img-wrap{
  img{
    width: 100%;
    height: 38vw;
  }
}
.coreIdea {
  width: 100%;
  display: flex;
  justify-content: space-between;
  .coreIdea-title {
    .underline {
      width: 180px;
      height: 4px;
      background: #dc1010;
    }
    .coreIdea-title-name {
      font-size: 36px;
      font-weight: 500;
      color: #dc1010;
      margin-top: 20px;
    }
  }
  .coreIdea-content {
    border-top: 1px solid #999;
    width: 1000px;
    padding-right: 20px;
    padding-top: 10px;
    display: flex;
    box-sizing: border-box;
    .coreIdea-content-left {
      width: 370px;
      margin-top: 22px;
      .coreIdea-content-mission {
        .title {
          display: block;
          font-size: 24px;
          font-weight: 500;
          color: #dc1010;
          margin-bottom: 20px;
        }
        .content {
          display: block;
          width: 370px;
          font-size: 20px;
          font-weight: 400;
          color: #333333;
          margin-bottom: 50px;
        }
      }
      .coreIdea-content-vision {
        .title {
          display: block;
          font-size: 24px;
          font-weight: 500;
          color: #dc1010;
          margin-bottom: 20px;
        }
        .content {
          display: block;
          width: 370px;
          font-size: 20px;
          font-weight: 400;
          color: #333333;
        }
      }
    }
    .coreIdea-content-right {
      margin-top: 22px;
      margin-left: 40px;
      .title {
        display: block;
        font-size: 24px;
        font-weight: 500;
        color: #dc1010;
        margin-bottom: 20px;
      }
      .content {
        display: block;
        font-size: 20px;
        font-weight: 400;
        color: #333333;
        line-height: 36px;
      }
    }
  }
}

.companyHistory {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
  .companyHistory-title {
    .underline {
      width: 180px;
      height: 4px;
      background: #dc1010;
    }
    .companyHistory-title-name {
      font-size: 36px;
      font-weight: 500;
      color: #dc1010;
      margin-top: 20px;
    }
  }

  .companyHistory-content {
    border-top: 1px solid #999;
    width: 1000px;
    padding-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;

    .companyHistory-content-year {
      margin-top: 20px;
      .companyHistory-content-year-span {
        display: inline-block;
        color: #d8d8d8;
        font-size: 26px;
        margin-right: 20px;
        cursor: pointer;
      }
    }
    .companyHistory-content-month {
      margin-top: 20px;
      width: 100%;
      height: 500px;
      display: flex;
      position: relative;
      .companyHistory-content-month-l {
        width: 100%;
        height: 500px;
        position: relative;
        img {
          width: 100%;
          height: 100%;
        }
        .companyHistory-introduce {
          width: 70%;
          height: 70%;
          position: absolute;
          top: 100px;
          left: 45px;
          font-size: 20px;
          color: #ffffff !important;
          overflow: auto;
          span {
            color: #ffffff !important;
          }
          &::-webkit-scrollbar {
            width: 10px;
            height: 10px;
          }
          &::-webkit-scrollbar-track {
            width: 6px;
            background: rgba(#101f1c, 0.1);
            -webkit-border-radius: 2em;
            -moz-border-radius: 2em;
            border-radius: 2em;
          }
          // 滚动条的轨道（里面装有Thumb）
          &::-webkit-scrollbar-thumb {
            background-color: rgba(144, 147, 153, 0.5);
            background-clip: padding-box;
            min-height: 28px;
            -webkit-border-radius: 2em;
            -moz-border-radius: 2em;
            border-radius: 2em;
            transition: background-color 0.3s;
            cursor: pointer;
          }
          &::-webkit-scrollbar-thumb:hover {
            background-color: rgba(144, 147, 153, 0.3);
          }
        }
      }

      .companyHistory-content-month-r {
        width: 20%;
        height: 500px;
        background: #393a3a;
        opacity: 0.7;
        box-sizing: border-box;
        overflow-y: auto;
        position: absolute;
        right: 0;
        &::-webkit-scrollbar {
          width: 10px;
          height: 10px;
        }
        &::-webkit-scrollbar-track {
          width: 6px;
          background: rgba(#101f1c, 0.1);
          -webkit-border-radius: 2em;
          -moz-border-radius: 2em;
          border-radius: 2em;
        }
        // 滚动条的轨道（里面装有Thumb）
        &::-webkit-scrollbar-thumb {
          background-color: rgba(144, 147, 153, 0.5);
          background-clip: padding-box;
          min-height: 28px;
          -webkit-border-radius: 2em;
          -moz-border-radius: 2em;
          border-radius: 2em;
          transition: background-color 0.3s;
          cursor: pointer;
        }
        &::-webkit-scrollbar-thumb:hover {
          background-color: rgba(144, 147, 153, 0.3);
        }

        .companyHistory-content-img-concrete {
          height: 100px;
          width: 100%;
          font-size: 26px;
          border-bottom: 1px solid #a3a3a3;
          box-sizing: border-box;
          color: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }
      }
    }
  }
}

.active {
  color: #d3231c !important;
}
.officeEnvironment {
  margin-top: 60px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  .officeEnvironment-title {
    .underline {
      width: 180px;
      height: 4px;
      background: #dc1010;
    }
    .officeEnvironment-title-name {
      font-size: 36px;
      font-weight: 500;
      color: #dc1010;
      margin-top: 20px;
    }
  }
  .officeEnvironment-content {
    border-top: 1px solid #999;
    width: 1000px;
    padding-right: 20px;
    padding-top: 10px;
    display: flex;
    box-sizing: border-box;
    height: 510px;
    // background-color: red;
    margin-bottom: 70px;
  }
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.mCompanyProfile {
  width: 85vw;
  margin: 0 auto;
  margin-top: 5.3333vw;
  padding-bottom: 20vw;
  .mCompanyProfile-title {
    display: flex;
    justify-content: center;
    font-size: 5.33vw;
    font-weight: 600;
    color: #dc1010;
    padding-bottom: 1.3333vw;
    margin-bottom: 1.3333vw;
  }
  .section-title{
    color: #333;
    font-size: 5.33vw;
    font-weight: bold;
    margin-top: 6.13vw;
  }
  .line{
    display: flex;
    margin-top: 5.33vw;
    width: 59.7vw;
    height: 1.6vw;
    background: url("../assets/Group\ 37340.png") no-repeat;
    background-size: cover;
  }
  .service-framewrok{
    margin-top: 9.86vw;
    ul{
      li{
        list-style: none;
        color: #666;
        font-size: 3.73vw;
        font-weight: 500;
        position: relative;
        padding-left: 5.33vw;
        line-height: 6.7vw;
        margin-top: 3.2vw;
        &::before{
          content: '•'; /* Unicode for bullet */
          position: absolute;
          left: 0;
          color: #BD2121; /* Change color as needed */
          font-size: 30px; /* Adjust size as needed */
          top: 0;
        }
      }
    }
    .row-ul{
      display: flex;
      li{
        flex: 1;
        &:nth-child(2){
          margin-left: 6vw;
        }
      }
    }
    img{
      width: 77.6vw;
      height: 77vw;
      margin-top: 5.33vw;
    }
  }
  .sence-item{
    background: #FFFFFF;
    box-shadow: 0px 4px 12px 0px rgba(208,2,27,0.06);
    border-radius: 3.73vw 3.73vw 3.73vw 3.73vw;
    margin-top: 5.86vw;
    padding: 4.53vw 5.86vw;
    .sence-item-title{
      color: #DB222A;
      font-size: 4.8vw;
      font-weight: bold;
    }
    .sence-item-content{
      color: #666;
      font-size: 3.73vw;
      font-weight: 500;
      line-height: 11.73vw;
      text-indent: 2em;
      margin-top: 5.33vw;
    }
  }
  .design{
    display: flex;
    margin-top: 15.4vw;
    img{
      width: 37.6vw;
      height: 294.66vw;
      flex-shrink: 0;
    }
    .design-wrap{
      .design-title{
        font-weight: bold;
        font-size: 4.8vw;
        color: #DB222A;
      }
      .design-content{
        font-weight: 500;
        font-size: 3.73vw;
        color: #666;
        margin-top: 4vw;
        line-height: 8.53vw;
        text-indent: 1em;
      }
    }
  }
  .people{
    margin-top: 9vw;
    display: flex;
    flex-direction: column;
    .people-type{
      font-weight: bold;
      font-size: 3.73vw;
      color: #333333;
      margin: 5vw 0;
    }
    .people-item{
      background: #FFFFFF;
      box-shadow: 0px 4px 12px 0px rgba(208,2,27,0.06);
      border-radius: 3.73vw 3.73vw 3.73vw 3.73vw;
      padding: 3.2vw 5.6vw;
      color: #666;
      font-weight: 500;
      font-size: 4.26vw;
      line-height: 11.7vw;
      margin-top: 4.26vw;
    }
  }
  .evaluate{
    margin-top: 9.6vw;
    .company{
      position: relative;
      background: rgba(189,33,33,0.05);
      border-radius: 3.73vw 3.73vw 3.73vw 3.73vw;
      padding: 4.26vw 3.73vw;
      text-align: right;
      font-weight: 500;
      font-size: 3.73vw;
      color: #666666;
      line-height: 11.7vw;
    }
    .company-type{
      position: absolute;
      top: 1vw;
      left:1vw;
      width: 19.4vw;
      height: 19.4vw;
      background: url("../assets/image\ 77.png") no-repeat;
      background-size: cover;
      font-weight: bold;
      font-size: 3.73vw;
      color: #FFFFFF;
      text-align: center;
    }
    .company-tips{
      position: absolute;
      bottom: 0;
      left: 0;
      text-align: left;
      background: #FFFFFF;
      box-shadow: 0px 4px 12px 0px rgba(208,2,27,0.06);
      border-radius: 3.73vw 3.73vw 3.73vw 3.73vw;
      font-weight: 500;
      font-size: 3.73vw;
      color: #666666;
      line-height: 11.7vw;
      padding: 3.2vw 4.53vw;
    }
    .img-wrap{
      display: flex;
      justify-content: center;
    }
  }
}
.mOfficeEnvironment {
  margin-top: 5.3333vw;
  .mOfficeEnvironment-title {
    display: flex;
    justify-content: center;
    font-size: 5.5vw;
    font-weight: 500;
    color: #dc1010;
    padding-bottom: 1.3333vw;
    margin-bottom: 1.3333vw;
  }

  .mswiper {
    width: 85vw;
    margin: 0 auto;
    .my-swipe .van-swipe-item {
      width: 100%;
      height: 53.3333vw;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>